// Landing page is served as a single static file from public/index.html.
// The React root stays empty on purpose.
function App() {
  return null;
}

export default App;
